import { CALL_API } from 'redux-api-middleware'
import { get } from 'utils/network'
import isInt from 'validator/lib/isInt'

export const searchStudent = (q) => {
  const query = {
    q,
    by: isInt(q) ? 'id' : 'last_name',
  }
  const request = get('/students/search', query)
  request.types = ['STUD_Q_REQ', 'STUD_Q_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Students/actions.js